export const isSameOrigin = (url: string) =>
  URL.parse(url, window.location.href)?.origin === window.location.origin;
